import { push } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default (client) => async (dispatch) => {

  dispatch(push(getTeamUrl(`clients/${client.id}/view`)))
  
}